module.exports = __webpack_public_path__ + "static/flags/SP-700bb27086db38ed29af907f482a518e.gif";